/**
 * The asset model type indicates what kind of asset it is (e.g. boiler, or tank).
 * This information can also help provide validation for what kinds of components
 * are allowed on an asset (e.g. waterwalls cannot be found in tanks)
 */
export enum GeckoAssetModelType {
  VerticalTank = 'vertical_tank',
  HorizontalTank = 'horizontal_tank',
  Piping = 'piping',
  LegacyBoiler = 'legacy_boiler',
  Ship = 'ship',
  MissileSilo = 'missile_silo',
  NuclearContainmentDome = 'nuclear_containment_dome',
  MachinedForging = 'machined_forging',
  PressureVessel = 'pressure_vessel',
  Hood = 'hood',
  Fan = 'fan',
  Blower = 'blower',
  Pump = 'pump',
  Motor = 'motor',
  Valve = 'valve',
}
/**
 * The asset model component type indicates the metadata that will be found on that
 * component (e.g. TankShell will have a radius and height)
 */
export enum GeckoComponentModelType {
  VerticalTankShell = 'vertical_tank_shell',
  TankFloor = 'tank_floor',
  TankFlatRoof = 'tank_flat_roof',
  HorizontalTankShell = 'horizontal_tank_shell',
  PipeSection = 'pipe_section',
  PipeElbow = 'pipe_elbow',
  PipeTJoint = 'pipe_tjoint',
  PipeEccentricReducer = 'pipe_eccentric_reducer',
  LegacyBoilerWalls = 'legacy_boiler_walls',
  ShipDeck = 'ship_deck',
  BasicShipHull = 'basic_ship_hull',
  LegacyCone = 'legacy_cone',
  Cone = 'cone',
  LaunchTube = 'launch_tube',
  Dome = 'dome',
  DomeWall = 'dome_wall',
  FlatCircularFloor = 'flat_circular_floor',
  VerticalTankFoundation = 'vertical_tank_foundation',
  MachinedForgingSimple = 'machined_forging_simple',
  PressureVesselShell = 'pressure_vessel_shell',
  HemisphericalHead = 'hemispherical_head',
  TorisphericalHead = 'torispherical_head',
  EllipsoidalHead = 'ellipsoidal_head',
  SphereFlatCap = 'sphere_flat_cap',
  HoodStraight = 'hood_straight',
  HoodBend = 'hood_bend',
}
/**
 * The asset model feature indicates the metadata that will be found on that component
 * feature (e.g. a Plate will have surface_specs, etc.)
 */
export enum GeckoFeatureModelType {
  Plate = 'plate',
  TubePlate = 'tube_plate',
  PolygonalPlate = 'polygonal_plate',
  Course = 'course',
  HorizontalWeld = 'horizontal_weld',
  VerticalWeld = 'vertical_weld',
  GenericHeadCircumferentialWeld = 'generic_head_circumferential_weld',
  GenericHeadRadialWeld = 'generic_head_radial_weld',
  Manway = 'manway',
  RectangularManway = 'rectangular_manway',
  Nozzle = 'nozzle',
  FixedSensor = 'fixed_sensor',
  AnnularRing = 'annular_ring',
  LegacyBoilerWall = 'legacy_boiler_wall',
  ShipDeckCompartment = 'ship_deck_compartment',
  ShipDeckChock = 'ship_deck_chock',
  ShipDeckBitt = 'ship_deck_bitt',
  ShipDeckHatch = 'ship_deck_hatch',
  ShipDeckLocker = 'ship_deck_locker',
  ShipDeckDrain = 'ship_deck_drain',
  ShipDeckLadder = 'ship_deck_ladder',
  ShipDeckBulkhead = 'ship_deck_bulkhead',
  ShipDeckDoor = 'ship_deck_door',
  ShipDeckCoaming = 'ship_deck_coaming',
  PipeNonIntegralSupport = 'pipe_non_integral_support',
  PipeIntegralSupport = 'pipe_integral_support',
  SeamWeld = 'seam_weld',
  CircumferentialWeld = 'circumferential_weld',
  PipeWrap = 'pipe_wrap',
  LegacyBoilerRepairRegion = 'legacy_boiler_repair_region',
  ConeCourse = 'cone_course',
  ConePlate = 'cone_plate',
  ConeCircumferentialWeld = 'cone_circumferential_weld',
  ConeRadialWeld = 'cone_radial_weld',
  CoatingRegion = 'coating_region',
  LinerRegion = 'liner_region',
  SphericalPlate = 'spherical_plate',
  LeakDetectionValve = 'leak_detection_valve',
  SkirtSupport = 'skirt_support',
  SaddleSupport = 'saddle_support',
  LegSupport = 'leg_support',
}
